import { clearCanvas, normalizeRange, setupCanvas } from './canvas-utils';
import type { CandlePoint } from '../engine';

export function renderCandlestickChart(canvas: HTMLCanvasElement, candles: CandlePoint[]): void {
    const setup = setupCanvas(canvas);
    if (!setup) return;
    const { ctx, width, height } = setup;

    clearCanvas(ctx, width, height);
    if (candles.length === 0) return;

    const highs = candles.map(c => c.high);
    const lows = candles.map(c => c.low);
    const { min, max } = normalizeRange([...highs, ...lows]);

    const candleW = Math.max(2, Math.floor(width / Math.max(1, candles.length) * 0.7));
    const px = (v: number) => height - ((v - min) / (max - min)) * height;

    candles.forEach((candle, i) => {
        const x = Math.floor((i / candles.length) * width);
        const openY = px(candle.open);
        const closeY = px(candle.close);
        const highY = px(candle.high);
        const lowY = px(candle.low);
        const up = candle.close >= candle.open;

        ctx.strokeStyle = up ? '#15b57a' : '#d94736';
        ctx.beginPath();
        ctx.moveTo(x, highY);
        ctx.lineTo(x, lowY);
        ctx.stroke();

        ctx.fillStyle = up ? '#15b57a' : '#d94736';
        const y = Math.min(openY, closeY);
        const h = Math.max(1, Math.abs(openY - closeY));
        ctx.fillRect(x - Math.floor(candleW / 2), y, candleW, h);
    });
}
